// src/pages/FaxEmails.jsx
// Opened from "Stop emailing me each new fax" at the end of a per-person
// fax email (3.59.2; …/portal/?fax-emails=1&e=…&t=…). No sign-in: the link's
// signature is the permission (backend routes/emailPrefs.js). Nothing
// changes until the button is pressed, so link checkers that open links on
// their own can't turn anyone's emails off. Turning them back on works here
// or in Preferences.
import { useEffect, useState } from 'react';
import { API_BASE } from '../firebase/config';
import { pathForTab, DEFAULT_TAB } from '../utils/tabRoutes';
import AuthShell, { AuthMessage } from '../components/AuthShell';
import { S } from './ChooseOwnPassword';

export function faxEmailsLinkFromLocation() {
  const q = new URLSearchParams(window.location.search);
  return q.get('fax-emails') ? { e: q.get('e') || '', t: q.get('t') || '' } : null;
}

export default function FaxEmails({ link }) {
  const [state, setState] = useState('checking');   // 'checking' | 'ready' | 'saving' | 'problem'
  const [info, setInfo] = useState({});              // { email, on, message }
  const qs = `e=${encodeURIComponent(link.e)}&t=${encodeURIComponent(link.t)}`;
  useEffect(() => {
    fetch(`${API_BASE}/email/fax-emails?${qs}`).then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => { if (!ok) throw new Error(j.error); setInfo(j); setState('ready'); })
      .catch(e => { setInfo({ message: e.message }); setState('problem'); });
  }, [qs]);
  async function change(on) {
    setState('saving');
    try {
      const r = await fetch(`${API_BASE}/email/${on ? 'resubscribe' : 'unsubscribe'}?${qs}`, { method: 'POST' });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error);
      setInfo(j); setState('ready');
    } catch (e) { setInfo({ message: e.message }); setState('problem'); }
  }
  const goToPortal = () => window.location.assign(pathForTab(DEFAULT_TAB));

  return (
    <AuthShell stack>
      <h1 style={S.title}>Fax emails</h1>
      {state === 'checking' && <p style={S.text}>Checking your link…</p>}
      {(state === 'ready' || state === 'saving') && (info.on ? (
        <>
          <p style={S.text}>You get an email for each new fax to your team’s number at <strong>{info.email}</strong>.</p>
          <p style={S.text}>Stop these emails? New faxes always show in your Inbox in the Fax Portal.</p>
          <button onClick={() => change(false)} disabled={state === 'saving'} className="auth-btn">{state === 'saving' ? 'Saving…' : 'Stop emailing me each new fax'}</button>
        </>
      ) : (
        <>
          <AuthMessage tone="success">Done. <strong>{info.email}</strong> won’t get an email for each new fax. New faxes still show in your Inbox.</AuthMessage>
          <p style={S.text}>Changed your mind? Turn them back on here, or any time in the Fax Portal under Preferences.</p>
          <button onClick={() => change(true)} disabled={state === 'saving'} className="auth-btn">{state === 'saving' ? 'Saving…' : 'Email me each new fax again'}</button>
          <button onClick={goToPortal} className="auth-btn" style={{ marginTop: 8 }}>Go to the Fax Portal</button>
        </>
      ))}
      {state === 'problem' && (
        <>
          <AuthMessage tone="error">{info.message || 'This link is not valid.'}</AuthMessage>
          <button onClick={goToPortal} className="auth-btn">Go to the Fax Portal</button>
        </>
      )}
    </AuthShell>
  );
}
